<div class="flex flex-row align-middle items-center">
  <nx-popover #buCodePopover>{{ 'header.bu-code.popover' | translate }}</nx-popover>
  <span [nxPopoverTriggerFor]="buCodePopover" nxPopoverTrigger="hover">{{ 'header.bu-code.label' | translate }}</span>
  @if (potentialBuCodesSignal().length) {
    <nx-formfield appearance="outline" class="pb-3 mr-5 ml-3">
      <nx-dropdown
        type="text"
        [formControl]="buCodeControl"
        [placeholder]="'header.bu-code.placeholder' | translate"
        data-testid="bu-code-selector"
        class="min-w-28"
      >
        @for (buCode of potentialBuCodesSignal(); track $index) {
          <nx-dropdown-item [value]="buCode" class="w-max">{{ buCode }}</nx-dropdown-item>
        }
      </nx-dropdown>
    </nx-formfield>
  } @else {
    <nx-spinner class="mx-3" />
  }
</div>
